import { ReadonlyCollectionRepository } from '../abstraction';
import { IndexedDbDataAccess } from '../../data-access/indexed-db.data-access';
import { Dictionary } from '../../types/dictionary';

export abstract class ReadonlyIndexedDbCollectionRepository<TItem, TParams extends Dictionary<any> | undefined> implements ReadonlyCollectionRepository<TItem[], TParams> {

  protected constructor(protected dataAccess: IndexedDbDataAccess,
                        protected databaseName: string,
                        protected objectStoreName: string) { }

  async load(params: TParams): Promise<TItem[]> {
    const location = {
      databaseName: this.databaseName,
      objectStoreName: this.objectStoreName,
      params
    };
    return await this.dataAccess.getAll(location);
  }
}
